function initSwiperPopup() {

  const popup = document.getElementById("seePopup");
  if (!popup) return;

  const closeBtn = popup.querySelector(".popup-close");
  const muteBtn = popup.querySelector("#muteToggle");

  const mainEl = document.querySelector(".see-it-in-action-slider");
  const popupEl = document.querySelector(".popup-swiper");

  if (!mainEl || !popupEl) return;

  // ✅ Move popup to body (z-index fix)
  if (popup.parentNode !== document.body) {
    document.body.appendChild(popup);
  }

  // ✅ Prevent duplicate init
  if (mainEl.classList.contains("swiper-initialized")) return;

  // ✅ MAIN SWIPER
  const mainSwiper = new Swiper(mainEl, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    direction: 'horizontal',
    mousewheel: {
      forceToAxis: true,
    },
    loop: false,
    speed: 800,
      slidesOffsetAfter: 0,
    observer: true,
    observeParents: true,
  });

  // ✅ POPUP SWIPER
  const popupSwiper = new Swiper(popupEl, {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: popup.querySelector('.swiper-button-next'),
      prevEl: popup.querySelector('.swiper-button-prev'),
    },
    observer: true,
    observeParents: true,
  });

  const slides = mainEl.querySelectorAll(".swiper-slide");
  let playbackUpdateTimer = null;
  let lastPlayedRealIndex = -1;

  function schedulePlaybackUpdate(delay = 0) {
    window.clearTimeout(playbackUpdateTimer);
    playbackUpdateTimer = window.setTimeout(() => {
      const activeIndex = popupSwiper.realIndex;
      if (activeIndex === lastPlayedRealIndex) return;

      lastPlayedRealIndex = activeIndex;
      handleVideoPlayback(popupEl, popup);
    }, delay);
  }

  // 👉 OPEN POPUP
  slides.forEach((slide, index) => {
    slide.addEventListener("click", () => {

      popup.classList.add("active");
      document.body.classList.add("no-scroll");

      lastPlayedRealIndex = -1;
      popupSwiper.slideTo(index);
      schedulePlaybackUpdate(200);
    });
  });

  // 👉 CLOSE POPUP
  function closePopup() {
    popup.classList.remove("active");
    document.body.classList.remove("no-scroll");
    lastPlayedRealIndex = -1;
    window.clearTimeout(playbackUpdateTimer);
    pauseAllVideos(popupEl);
  }

  closeBtn?.addEventListener("click", closePopup);

  // 👉 CLICK OUTSIDE CLOSE
  popup.addEventListener("click", (e) => {
    if (e.target === popup) closePopup();
  });

  // 👉 SLIDE CHANGE (SWIPE)
  popupSwiper.on("slideChangeTransitionEnd", () => {
    schedulePlaybackUpdate();
  });

}


/* ---------- VIDEO HELPERS ---------- */

function pauseAllVideos(container) {
  container.querySelectorAll("video").forEach(v => {
    v.pause();
    v.currentTime = 0;
  });
}


function handleVideoPlayback(container, popup) {

  pauseAllVideos(container);

  const activeSlide = container.querySelector(".swiper-slide-active");
  const activeVideo = activeSlide?.querySelector("video");
  const muteBtn = popup.querySelector("#muteToggle");

  // 👉 ALWAYS RESET TO MUTED
  let isMuted = true;

  if (activeVideo) {

    // ✅ Show mute button
    if (muteBtn) {
      muteBtn.style.display = "block";
      muteBtn.classList.remove("active"); // show muted icon
    }

    activeVideo.muted = true;
    activeVideo.playsInline = true;

    const playPromise = activeVideo.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }

    // 👉 Toggle only for this slide
    muteBtn.onclick = () => {
      isMuted = !isMuted;
      activeVideo.muted = isMuted;

      // toggle icon
      muteBtn.classList.toggle("active", !isMuted);
    };

  } else {
    // ❌ Hide for image slides
    if (muteBtn) {
      muteBtn.style.display = "none";
    }
  }
}


/* ---------- INIT ---------- */

document.addEventListener("DOMContentLoaded", initSwiperPopup);
document.addEventListener("shopify:section:load", initSwiperPopup);
